var $ = jQuery;

function init() {
  $('.heritage-icon-print').on('click', function() {
    // No longer using JS to add variable and open in new window.
    // Check heritage_build.module to see new route.
    //var printUrl = window.location.href + '?print=true';
    //window.open(printUrl, '_blank');
  });
}

export { init as init };
